import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  id: "chat",
  class: "new-chat"
}
const _hoisted_2 = {
  key: 0,
  class: "burger-icon"
}
const _hoisted_3 = { class: "new-chat-content" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Burger = _resolveComponent("Burger")
  const _component_ChatInput = _resolveComponent("ChatInput")

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    (_ctx.$responsive.mobile)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_Burger)
        ]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_3, [
      _cache[1] || (_cache[1] = _createElementVNode("h1", null, "Where should we start?", -1 /* HOISTED */)),
      _createVNode(_component_ChatInput, {
        ref: "input",
        modelValue: $data.input_text,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.input_text) = $event)),
        class: "chat-input",
        shadow: "",
        controls: _ctx.$responsive.desktop,
        description: _ctx.$responsive.mobile ? 'Genrate can make mistakes. Check important information.' : '',
        placeholder: _ctx.$responsive.mobile ? 'Ask anything...' : 'Ask anything, or type / to run a skill…',
        onRegenerate: $options.onChat
      }, null, 8 /* PROPS */, ["modelValue", "controls", "description", "placeholder", "onRegenerate"])
    ])
  ]))
}